import { render, staticRenderFns } from "./GlobalStatistique.vue?vue&type=template&id=0f577e6a"
import script from "./GlobalStatistique.ts?vue&type=script&lang=ts&external"
export * from "./GlobalStatistique.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports